import { render } from "./Dept-Leader.vue?vue&type=template&id=832a7758&scoped=true"
import script from "./Dept-Leader.vue?vue&type=script&lang=js"
export * from "./Dept-Leader.vue?vue&type=script&lang=js"

import "./Dept-Leader.vue?vue&type=style&index=0&id=832a7758&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-832a7758"

export default script